import { updateNotification } from "./utils/updateNotification";
import { events } from "@planzone/events";
import { createStateReducer } from "../utils/createStateReducer";
import { initialState } from "./initialState";

const reduceAccountCreationNotificationState = createStateReducer(
  initialState,
  {
    [events.createAccountSucceeded]: (state) => ({
      ...state,
      queue: updateNotification(
        {
          key: "createAccount",
          flags: ["success"],
          args: { success: "true" },
        },
        state.queue,
      ),
    }),
    [events.createAccountFailed]: (state, { error: { message } }) => ({
      ...state,
      queue: updateNotification(
        {
          key: "createAccount",
          flags: ["failure"],
          args: { failure: "true", message },
        },
        state.queue,
      ),
    }),
  },
);

export { reduceAccountCreationNotificationState };
